import {
  AfterViewInit,
  Directive,
  ElementRef,
  Host,
  Input, OnChanges,
  OnDestroy,
  Optional, SimpleChanges,
} from "@angular/core";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Directive({
  selector: '[atlTooltipWidthDisabled]',
  standalone: true,
})
export class TooltipWidthDisabledDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input() disableTooltipFn?: () => boolean;
  @Input() tooltipWidthDisabledOfElement?: HTMLElement;
  @Input() disableTooltip = false;
  @Input() forceEnableTooltip = false;

  private resizeObserver!: ResizeObserver;

  constructor(private elementRef: ElementRef, @Host() @Optional() private tooltip: NgbTooltip) {}

  ngAfterViewInit(): void {
    this.updateState();

    this.resizeObserver = new ResizeObserver(() => {
      this.updateState();
    });

    const target = this.tooltipWidthDisabledOfElement ?? this.elementRef.nativeElement;
    this.resizeObserver.observe(target);
  }

  ngOnChanges(): void {
    this.updateState();
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private updateState(): void {
    if (!this.tooltip) return;

    const target = this.tooltipWidthDisabledOfElement ?? this.elementRef.nativeElement;

    const widthBasedCondition = this.disableTooltip || target.offsetWidth >= target.scrollWidth;
    const additionalCondition = this.disableTooltipFn?.() ?? false;

    this.tooltip.disableTooltip = this.forceEnableTooltip ? false : (widthBasedCondition || additionalCondition);
  }
}
